"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PopupItem = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const hooks_1 = require("../../hooks");
const style_module_scss_1 = __importDefault(require("./style.module.scss"));
const Context_1 = require("../../Context");
;
const PopupItem = (_a) => {
    var { className, onClick } = _a, props = __rest(_a, ["className", "onClick"]);
    const Styles = (0, hooks_1.useStyle)(style_module_scss_1.default, '_popup-');
    const { hide } = (0, react_1.useContext)(Context_1.ContainerContext);
    const handleClick = (0, react_1.useCallback)((e) => {
        if (typeof onClick === 'function') {
            onClick(e);
        }
        hide();
    }, [onClick]);
    return ((0, jsx_runtime_1.jsx)("button", Object.assign({}, props, { className: Styles('popup-item') + (className ? ` ${className}` : ''), onClick: handleClick })));
};
exports.PopupItem = PopupItem;
